/**
 * CheckboxTick renderer — simple manual confirmation.
 */
import React, { useState, useEffect } from 'react';
import { CheckCircle2 } from 'lucide-react';

export default function CheckboxTick({ action, value, onChange, onNext, onBack, canBack }) {
  const params = action.params || {};
  const [checked, setChecked] = useState(!!value);
  useEffect(() => { setChecked(!!value); }, [action.id]);   // eslint-disable-line react-hooks/exhaustive-deps

  const toggle = () => {
    const next = !checked;
    setChecked(next);
    onChange(next);
  };

  return (
    <div>
      <div className="bg-gradient-to-br from-emerald-50 to-white border-l-4 border-emerald-400 rounded-r-lg p-6 mb-6">
        <div className="text-[10px] uppercase tracking-widest text-emerald-600 font-semibold mb-2">✅ Confirm</div>
        <div className="text-lg text-slate-800 leading-relaxed" data-testid="wf-check-label">{params.label || 'Confirm this step'}</div>
      </div>

      <label className="flex items-center gap-3 p-6 mb-6 border-2 border-slate-200 rounded cursor-pointer hover:bg-slate-50">
        <input type="checkbox" checked={checked} onChange={toggle}
          data-testid="wf-check-input"
          className="w-6 h-6" />
        <CheckCircle2 size={24} className={checked ? 'text-emerald-500' : 'text-slate-300'} />
        <span className={`text-base font-medium ${checked ? 'text-slate-700' : 'text-slate-500'}`}>
          {checked ? 'Confirmed' : 'Tick to confirm'}
        </span>
      </label>

      <div className="flex items-center gap-3">
        {canBack && <button onClick={onBack} data-testid="wf-back-btn"
          className="px-4 py-2 text-slate-500 hover:text-slate-700">← Back</button>}
        <span className="flex-1" />
        <button onClick={onNext} disabled={!checked}
          data-testid="wf-next-btn"
          className="px-6 py-2 bg-sky-600 text-white font-semibold rounded hover:bg-sky-700 disabled:opacity-40">Next →</button>
      </div>
    </div>
  );
}
